import { Decimal } from 'decimal.js';

declare global {
    interface Math {
        add(a: number | string, b: number | string): number;
        sub(a: number | string, b: number | string): number;
        mul(a: number | string, b: number | string): number;
        div(a: number | string, b: number | string): number;
    }
    interface Number {
        add(a: number | string): number;
        sub(a: number | string): number;
        mul(a: number | string): number;
        div(a: number | string): number;
    }
}

export default function () {
    // 高精度加法计算
    Math.add = (a, b) => new Decimal(a).add(new Decimal(b)).toNumber();
    // 高精度减法计算
    Math.sub = (a, b) => new Decimal(a).sub(new Decimal(b)).toNumber();
    // 高精度乘法计算
    Math.mul = (a, b) => new Decimal(a).mul(new Decimal(b)).toNumber();
    // 高精度除法计算
    Math.div = (a, b) => new Decimal(a).div(new Decimal(b)).toNumber();

    Number.prototype.add = function(num){
        return new Decimal(this).add(new Decimal(num)).toNumber();
    };
    Number.prototype.sub = function(num){
        return new Decimal(this).sub(new Decimal(num)).toNumber();
    };
    Number.prototype.mul = function(num){
        return new Decimal(this).mul(new Decimal(num)).toNumber();
    };
    Number.prototype.div = function(num){
        return new Decimal(this).div(new Decimal(num)).toNumber();
    };
    // 覆盖Number原生toFixed方法
    Number.prototype.toFixed = function(num){
        return new Decimal(this).toFixed(num);
    };
}
